// deepcode ignore HardcodedNonCryptoSecret: não é uma secret, apenas o valor da key que terá o secret como value
const accessTokenCookieKey = "@FC:Ecom:Token:Access";
// deepcode ignore HardcodedNonCryptoSecret: não é uma secret, apenas o valor da key que terá o secret como value
const refreshTokenCookieKey = "@FC:Ecom:Token:Refresh";

export { accessTokenCookieKey, refreshTokenCookieKey };
